import React from "react";
import { connect } from "react-redux";
import CheckCircleOutlineIcon from "../../components/CheckCircleOutlineIcon";
// import CheckCircleIcon from 'material-ui/svg-icons/action/check-circle'
// import CheckCircleIcon from 'material-ui/svg-icons/navigation/check'
// import CheckCircleIcon from 'material-ui/svg-icons/toggle/check-box-outline-blank'
// import CheckCircleIcon from 'material-ui/svg-icons/toggle/check-box'

// SVG Derived from: https://materialdesignicons.com/icon/check-circle-outline

import "./styles.css";

let OrderConfirmation = ({ orderId }) => (
  <div class="order-confirmation">
    <div class="order-confirmation__content">
      <CheckCircleOutlineIcon />
      <div>
        {" "}
        Your order was placed successfully! Your confirmation number is{" "}
        <b>{orderId}</b>{" "}
      </div>
      <div> You will receive an email receipt. </div>
    </div>
  </div>
);

function mapStateToProps(state) {
  return {
    orderId: state.orders.orderId
  };
}

export default connect(mapStateToProps)(OrderConfirmation);

// <svg className='' viewBox='0 0 24 24'>
//   <path d='M3,13H5.79L10.1,4.79L11.28,13.75L14.5,9.66L17.83,13H21V15H17L14.67,12.67L9.92,18.73L8.94,11.31L7,15H3V13Z' />
// </svg>



// WEBPACK FOOTER //
// ./src/scenes/OrderConfirmation/index.js